import React from "react";

import * as typography from "@client/shared/typography";

import {ManagerLayout} from "@client/site/ManagerLayout";
import * as forms from "@client/site/forms";
import {server} from "@reactivated";

import {ClientNavigation} from "./ClientManagerPlanner";

const managerLayoutStyles = {
    spacer: "space-y-[15px] flex flex-col",
    form: "manager-form space-y-[15px] max-w-[400px]",
};

export const Template = (props: server.manager.templates.DeleteMealPlan) => {
    const title = "Delete meal plan";
    const action = "Delete";

    const [isSubmitting, setIsSubmitting] = React.useState(false);

    const handleSubmit = () => {
        setIsSubmitting(true);
    };

    return (
        <ManagerLayout narrow title={title} currentClientManagerId={null}>
            <form
                className={managerLayoutStyles.spacer}
                onSubmit={handleSubmit}
                noValidate
                method="POST"
                action=""
            >
                <forms.CSRFToken />
                <ClientNavigation>
                    <typography.Header>{title}</typography.Header>
                </ClientNavigation>
                <typography.P>
                    Please confirm you’d like to delete{" "}
                    <strong>{props.meal_plan.name}</strong>
                </typography.P>

                <typography.P>This action is permanent.</typography.P>

                <div className={managerLayoutStyles.form}>
                    <forms.Fields form={props.form} />
                </div>
                <typography.Button submit disabled={isSubmitting}>
                    {action}
                </typography.Button>
            </form>
        </ManagerLayout>
    );
};
